<template>
  <a class="home-ranking-card" :href="project.href" :aria-label="`${project.name}, posicao ${rankLabel}`">
    <span class="home-ranking-card__media">
      <img class="home-ranking-card__cover" :src="project.project_thumb" :alt="project.name" loading="lazy" @error="onImageError" />
      <span class="home-ranking-card__badge">{{ project.name }}</span>
      <span
        v-if="project.ageRatingLabel"
        class="home-age-rating"
        :class="project.ageRatingClass"
        :aria-label="`Classificacao indicativa ${project.ageRatingLabel}`"
      >
        {{ project.ageRatingLabel }}
      </span>
    </span>
    <span class="home-ranking-card__rank">{{ rankLabel }}</span>
  </a>
</template>

<script>
import { HOME_PROJECT_FALLBACK, setImageFallback } from "@/utils/homeImageFallbacks";

export default {
  name: "HomeRankingCard",
  props: {
    project: { type: Object, required: true },
    showViews: { type: Boolean, default: true },
  },
  computed: {
    rankLabel() {
      return String(this.project.rank || 0);
    },
  },
  methods: {
    onImageError(event) {
      setImageFallback(event, HOME_PROJECT_FALLBACK);
    },
  },
};
</script>
